import i18n from 'i18next';
export const setUserLanguage = () => {
    const currentLanguage = i18n.resolvedLanguage;
    const userLanguage = window.bifrostAuth.accessTokenPayload?.locale;
    if (userLanguage && userLanguage !== currentLanguage) {
        i18n.changeLanguage(userLanguage);
    }
};
